import { FTimestampFunc } from '@playback-rewards/shared-libraries'
import { Timestamp } from 'firebase/firestore'

FTimestampFunc.new = (seconds: number, nanoseconds: number) => {
  return new Timestamp(seconds, nanoseconds)
}
FTimestampFunc.now = () => Timestamp.now()
